import { render, staticRenderFns } from "./DriftFacade.vue?vue&type=template&id=0cd78e0f&scoped=true&"
import script from "./DriftFacade.vue?vue&type=script&lang=ts&"
export * from "./DriftFacade.vue?vue&type=script&lang=ts&"
import style0 from "./DriftFacade.vue?vue&type=style&index=0&id=0cd78e0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd78e0f",
  null
  
)

export default component.exports